import { ref } from 'vue'
import { message } from 'ant-design-vue'
import { UploadService } from '@/api/upload'
import useCreateElement from './useCreateElement'
export default () => {
  const params = ref({})
  const {
    createSvgElement,
    createShapeElement,
  } = useCreateElement();
  const userUpload = async (file: any, base64: any) => {
    let type = 'png'
    if (file.type === 'image/jpeg') {
      type = 'jpg'
    }
    else if (file.type === 'image/png') {
      type = 'png'
    }
    else if (file.type === 'image/gif') {
      type = 'gif'
    }
    else if (file.type === 'image/svg+xml') {
      const data = new FormData();
      data.append("file", file);
      const res = await UploadService.uploadSvg(data);
      if (res.data.state === 2) {
        const codes = JSON.parse(res.data.data);
        if (codes.type === "shape") {
          createShapeElement(codes);
        } else {
          createSvgElement(codes);
        }
      } else {
        message.error(res.data.msg);
      }
      return false
    }
    else {
      message.error('暂不支持的格式')
      return false
    }
    const isLt2M = file.size / 1024 / 1024 < 5
    if (!isLt2M) {
      message.error('上传文件大小不能超过 5MB!')
      return false
    }
    
    let url = ''
    await getFileWidthAndHeight(file,5000,5000).then(async r => {
      if (!r) {
        return false
      }
      params.value = {
        height:'',
        width:'',
        type: type,
        base64Data:base64
      }
      const hide = message.loading('正在上传中..', 0)
        
      const res = await UploadService.base64image(params.value)
      if (Number(res.data.state) === 2) {
        url = res.data.result
        
        message.success('已添加到当前编辑器')
      }
      else {
        message.info(res.data.message)
      }
      setTimeout(hide, 100)
      
    })
    return url
  }
  const getFileWidthAndHeight = (file: Blob, initwidth: any, initheight: any) => {

    return new Promise<void>((resolve, reject) => {
      const width = initwidth
      const height = initheight
      const _URL = window.URL || window.webkitURL
      const img = new Image()
      img.src = _URL.createObjectURL(file)
      img.onload = function() {
        const valid = img.width <= width && img.height <= height
        valid ? resolve() : reject()
      }
      img.src = _URL.createObjectURL(file)
    }).then(
      () => {
        return true
      },
      () => {
        message.error("图片像素过大（超出5000px），请压缩后上传！")
        return Promise.reject()
      }
    )
  }
  const base64Upload = async (base64: any) => {
    const type = 'png'
    let url = ''
    params.value = {
      height:'',
      width:'',
      type: type,
      base64Data:base64
    }
    const res = await UploadService.base64image(params.value)
    if (Number(res.data.state) === 2) {
      url = res.data.result
    }
    else {
      message.info(res.data.message)
    }
    return url
  }
  return {
    userUpload,
    base64Upload
  }
}
